export default "__VITE_ASSET__Cg1Rq$tP__"